var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02a9f4",
    d: "M32 12a3 3 0 001 2.2 10 10 0 00-8 9.8v12a3 3 0 00-3 3v3h8a5 5 0 005 5v4a3 3 0 01-3 3H4a3 3 0 01-3-3V4a3 3 0 013-3h4l2.86 3.05a3 3 0 002.19 1H23a3 3 0 002.19-1L28 1h4a3 3 0 013 3v5a3 3 0 00-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0377bc",
    d: "M30 42h-3a5 5 0 005 5v4a3 3 0 01-3 3h3a3 3 0 003-3v-4a5 5 0 01-5-5zM32 1h-3a3 3 0 013 3v5a3 3 0 00-3 3 3 3 0 001 2.2 10 10 0 00-8 9.8v12a3 3 0 00-3 3v3h3v-3a3 3 0 013-3V24a10 10 0 018-9.8 3 3 0 01-1-2.2 3 3 0 013-3V4a3 3 0 00-3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#607d8b",
    d: "M35 51v5a3 3 0 01-3 3H4a3 3 0 01-3-3v-5a3 3 0 003 3h28a3 3 0 003-3zM28 1l-2.86 3.05A3 3 0 0123 5h-9.9a3 3 0 01-2.19-1L8 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37474f",
    d: "M25 1l-2.86 3.05A3 3 0 0120 5h3a3 3 0 002.19-1L28 1zM32 54v2a3 3 0 01-3 3h3a3 3 0 003-3v-5a3 3 0 01-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3a",
    d: "M45 24v12H25V24a10 10 0 018-9.8 10.4 10.4 0 014.06 0A10 10 0 0145 24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdd834",
    d: "M42.07 16.93a10.05 10.05 0 00-5-2.73 10.35 10.35 0 00-2-.2 10.59 10.59 0 00-1.5.12l.53.08A10 10 0 0142 24v12h3V24a10 10 0 00-2.93-7.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdc00",
    d: "M48 39v3H22v-3a3 3 0 013-3h20a3 3 0 013 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec108",
    d: "M45 36h-3a3 3 0 013 3v3h3v-3a3 3 0 00-3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9801",
    d: "M40 42a5 5 0 01-10 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f57c00",
    d: "M37 42a5 5 0 01-3.5 4.75A4.95 4.95 0 0040 42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9801",
    d: "M38 12a3 3 0 01-1 2.2 10.4 10.4 0 00-4.06 0A3 3 0 0132 12a3 3 0 016 0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 60h28a4 4 0 004-4v-8.09A6 6 0 0040.91 43H48a1 1 0 001-1v-3a4 4 0 00-3-3.86V24a11 11 0 00-7.35-10.37A3.91 3.91 0 0039 12a4 4 0 00-3-3.86V4a4 4 0 00-4-4H4a4 4 0 00-4 4v52a4 4 0 004 4zm28-2H4a2 2 0 01-2-2v-1.56A3.91 3.91 0 004 55h28a3.91 3.91 0 002-.56V56a2 2 0 01-2 2zm3-12a4 4 0 01-3.86-3h7.72A4 4 0 0135 46zm12-7v2H23v-2a2 2 0 012-2h20a2 2 0 012 2zm-3-15v11H26V24a9 9 0 0118 0zm-7-12a2 2 0 01-.36 1.14 9.68 9.68 0 00-3.28 0A2 2 0 1137 12zM25.69 2l-1.28 1.37A2 2 0 0123 4h-9.9a2 2 0 01-1.46-.63L10.31 2zM2 4a2 2 0 012-2h3.57l2.56 2.74A4 4 0 0013.05 6H23a4 4 0 002.92-1.26L28.43 2H32a2 2 0 012 2v4.14A4 4 0 0031 12a3.91 3.91 0 00.35 1.63A11 11 0 0024 24v11.14A4 4 0 0021 39v3a1 1 0 001 1h7.09A6 6 0 0034 47.91V51a2 2 0 01-2 2H4a2 2 0 01-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 33a1 1 0 001-1c0-6.627 5.373-12 12-12a1 1 0 000-2c-7.732 0-14 6.268-14 14a1 1 0 001 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 22c-5.523 0-10 4.477-10 10a1 1 0 002 0 8 8 0 018-8 1 1 0 000-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 26a6 6 0 00-6 6 1 1 0 002 0 4 4 0 014-4 1 1 0 000-2zM44 58a1 1 0 000 2 14 14 0 0014-14 1 1 0 00-2 0c0 6.627-5.373 12-12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 54a1 1 0 000 2c5.523 0 10-4.477 10-10a1 1 0 00-2 0 8 8 0 01-8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 46a4 4 0 01-4 4 1 1 0 000 2 6 6 0 006-6 1 1 0 00-2 0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.60ee5ddc.svg";
export { ForwardRef as ReactComponent };